module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "ORIM-Blockquote-First-w-Hanging-Indent--Body- ParaOverride-1"
  }, [_vm._v("A Faithful Record of Their Amazing Adventures")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("in an Underground World; and How with the")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("Aid of Their Friends Zeb Hugson, Eureka")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("the Kitten, and Jim the Cab-Horse,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("They Finally Reached the")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("Wonderful Land")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_vm._v("of Oz"), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e574e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Epigraph.vue
// module id = 69
// module chunks = 0